<template>
    <div class="panel__container">
        <user-invitations @back="goBack" :message="message" action="tenant/inviteMembers" :channels="activeChannels" :role="role">
            <template slot="invite_users_title">{{ title }}</template>
            <template slot="confirmation_label">To be invited to <strong>{{ currentTenant.display_name }}</strong></template>
        </user-invitations>
    </div>
</template>
<script>
/* global app */
import { mapGetters, mapState } from 'vuex'
import UserInvitations from '../../Global/Users/UserInvitations'

export default {
    props: {
        role: {
            required: true,
            type: String
        }
    },

    data () {
        return {
            message: '',
            currentTenant: app.currentTenant,
            roles: app.config.USER_ROLES
        }
    },

    created () {
        this.message = `${this.currentUser.display_name} invited you to join '${this.currentTenant.display_name}' on Skybase.`
    },

    methods: {
        goBack () {
            this.$router.push({ path: '/people/options' })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapGetters(['activeChannels']),

        title () {
            return `Invite ${this.roles[this.role].toLowerCase()}s`
        }
    },

    components: {
        UserInvitations
    }
}
</script>
